export default __webpack_public_path__ + "static/media/pic9.12c44cf5.svg";